import React, { createContext, useContext, useState } from 'react';
import { translations } from '../data/menuData';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('bg');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'bg' ? 'en' : 'bg');
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  const getName = (item) => {
    return language === 'bg' ? item.name_bg : item.name_en;
  };

  const getDescription = (item) => {
    return language === 'bg' ? item.description_bg : item.description_en;
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      toggleLanguage, 
      t, 
      getName, 
      getDescription 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
